import React, { useEffect, useState } from "react";
import * as S from "../../style/StyleComponentSection";
import * as U from "../../style/StyleComponentUtility";
import arrowIcon from "../../assets/icons/arrow_forward_ios.svg";
import { get_select_my_community, update_portfolio_inactive_one } from "../../Axios";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import Pagination from "../Utility/Pagination";
import closeIcon from "../../assets/icons/close.svg";
import editIcon from "../../assets/icons/edit_square.svg";
import { get_day_timestamp } from "../../Validation";
import { useNavigate } from "react-router-dom";

interface MyCommunityObject {
    ablack_comunity_ID : number;
    ablack_comunity_brand_ID : number;
    brand_kor_name : string;
    ablack_comunity_color_ID : number;
    color_name : string;
    product_kor_name : string;
    ablack_comunity_customer_ID : number;
    ablack_comunity_division : number;
    ablack_comunity_division_name : string;
    ablack_comunity_img_file1 : string;
    ablack_comunity_img_file2 : string;
    ablack_comunity_img_file3 : string;
    ablack_comunity_img_file4 : string;
    ablack_comunity_img_file5 : string;
    ablack_comunity_modified : string;
    ablack_comunity_registe : Date;
    ablack_comunity_review : string;
    ablack_comunity_top_status : number;
};

const CommunityDetail: React.FC = () => {
    const navigate = useNavigate();
    
    const customerData = useSelector((state: RootState) => state.customerData);
    const [page, setPage] = useState<number>(1);
    const [listCount] = useState<number>(10);
    const [field, setField] = useState<number>(0);
    const [listOrder, setListOrder] = useState<number>(0);
    const [myCommunityList, setMyCommunityList] = useState<MyCommunityObject[]>([]);
    const [totalMyCommunity, setTotalMyCommunity] = useState<number>(0);

    useEffect(() => {
        handleSelectMyCommunity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerData.customer_ID, field, listCount, listOrder, page]);

    const handleSelectMyCommunity = () => {
        get_select_my_community(
            customerData.customer_ID,
            page,
            listCount,
            field,
            listOrder
        ).then(result => {
            setMyCommunityList(result.rows);
            setTotalMyCommunity(result.total_count);
        })
    }

    const handlePage = (page: number) => {
        setPage(page);
    };

    const handleSort = (field_num: number) => {
        if(field !== field_num) {
            setField(field_num);
            setListOrder(1);
        } else {
            if(listOrder === 1) {
                setListOrder(0);
            } else if (listOrder === 0) {
                setField(0)
            }
        };
        setPage(1) // 정렬시 1페이지로 이동 => 삭제해도 무방
    };

    return (
        <S.SectionContainer>
            <S.SectionWidth $width={1080}>

                <S.SectionTitleBox>
                    <h1>포트폴리오 작성 내역</h1>
                    <h3>작성한 포트폴리오 내역을 확인할 수 있습니다.</h3>
                </S.SectionTitleBox>

                <U.BreakLine $height={60} />

                {/* 구분 브랜드명 제품명 리뷰 AP 적립 내역, 작성일자 수정 삭제 */}
                <S.ReservationTableHead>
                    <div className="sortable-box w-20" onClick={() => handleSort(1)}>
                        <span>
                            구분
                            <img src={arrowIcon} className={`${field === 1 ? `block ${listOrder === 0 ? "rotate-90" : "rotate-[270deg]"}` : "hidden"}`} alt="" />
                        </span>
                    </div>
                    <div className="sortable-box w-20" onClick={() => handleSort(2)}>
                        <span>브랜드명
                            <img src={arrowIcon} className={`${field === 2 ? `block ${listOrder === 0 ? "rotate-90" : "rotate-[270deg]"}` : "hidden"}`} alt="" />
                        </span>
                    </div>
                    <div className="sortable-box w-44" onClick={() => handleSort(3)}>
                        <span>
                            제품명
                            <img src={arrowIcon} className={`${field === 3 ? `block ${listOrder === 0 ? "rotate-90" : "rotate-[270deg]"}` : "hidden"}`} alt="" />
                        </span>
                    </div>
                    <div className="flexible-hide-box w-[30%]" onClick={() => handleSort(4)}>
                        <span>
                            리뷰
                            <img src={arrowIcon} className={`${field === 4 ? `block ${listOrder === 0 ? "rotate-90" : "rotate-[270deg]"}` : "hidden"}`} alt="" />
                        </span>
                    </div>
                    <div className="sortable-box w-24">
                        <span>
                            AP 적립 내역
                            <img src={arrowIcon} className={`${field === 8 ? `block ${listOrder === 0 ? "rotate-90" : "rotate-[270deg]"}` : "hidden"}`} alt="" />
                        </span>
                    </div>
                    <div className="sortable-box w-24" onClick={() => handleSort(5)}>
                        <span>
                            작성일자
                            <img src={arrowIcon} className={`${field === 5 ? `block ${listOrder === 0 ? "rotate-90" : "rotate-[270deg]"}` : "hidden"}`} alt="" />
                        </span>
                    </div>
                    <div className="w-10 cursor-default">수정</div>
                    <div className="w-12 cursor-default">삭제</div>
                </S.ReservationTableHead>

                <div>
                    {myCommunityList.map((tmp, idx) => 
                        <S.ReservationTableBody
                            className="h-10 cursor-pointer"
                            $withBtn
                            key={tmp.ablack_comunity_ID}
                            onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                                const target = e.target as HTMLElement;
                                if(target.classList.contains('edit-icon') || target.classList.contains('edit-icon-box')) return;
                                navigate('/portfolio_select_one', {state : {ablack_comunity_ID : tmp.ablack_comunity_ID}});
                            }
                        }>
                            <div className="w-20">{tmp.ablack_comunity_division_name}</div>
                            <div className="w-20">{tmp.brand_kor_name}</div>
                            <div className="w-44 md:text-[12px]">{`${tmp.product_kor_name} - ${tmp.color_name}`}</div>
                            <div className="w-[30%] request-box md:hidden">{tmp.ablack_comunity_review}</div>
                            <div className="w-24">500 AP</div>
                            <div className="w-24">{(get_day_timestamp(tmp.ablack_comunity_registe).year_month_day)}</div>
                            <div className="w-10 flex justify-center edit-icon-box" onClick={() => navigate('/modify_portfolio', {state : tmp.ablack_comunity_ID})}>
                                <img className="edit-icon" src={editIcon} alt="" />
                            </div>
                            <div className="w-12 flex justify-center edit-icon-box" onClick={() => {
                                if(!window.confirm(`${tmp.product_kor_name} - ${tmp.color_name}의 후기를 삭제하시겠습니까?`)) return;
                                update_portfolio_inactive_one(tmp.ablack_comunity_ID, customerData.customer_ID).then(result => {
                                    if(result === 1) {
                                        alert('삭제되었습니다.');
                                        handleSelectMyCommunity();
                                    } else {
                                        alert('알 수 없는 오류');
                                    }
                                });
                            }}>
                                <img className="edit-icon" src={closeIcon} alt="" />
                            </div>
                        </S.ReservationTableBody>
                    )}
                </div>

                <Pagination totalCount={totalMyCommunity} handlePage={handlePage} listCount={listCount} page={page} />

            </S.SectionWidth>

            {/* {modal &&
                <CommunitySelectOne communityID={selectOneCommunityID} handleOffModal={handleOffModal} />
            } */}
        </S.SectionContainer>
    )
};

export default CommunityDetail;